























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { CreateElement, VNode } from 'vue';
import { FeedStateModule } from '../../store';

@Component<Post>({})
export default class Post extends Vue {
  // PROPS
  @Prop({
    type: Boolean,
    required: true,
    default: false,
  })
  shows!: boolean;
  @Prop({
    type: Function,
    required: true,
    default: () => Promise.reject(),
  })
  requestFn!: () => Promise<any>;

  // FIELDS
  isLoading = true;
  hasError = false;

  // METHODS
  @Watch('shows', { immediate: true })
  onChangeShows(cur: boolean, old: boolean) {
    if (cur === true) {
      this.exec();
    }
  }
  exec() {
    this.requestFn()
      .then(() => FeedStateModule.clear())
      .catch((err) => {
        console.error(err);
        this.hasError = true;
      })
      .finally(() => (this.isLoading = false));
  }
  routeTo() {
    this.$emit('update:shows', false);
    if (!this.hasError) {
      this.$router.push('/');
    }
  }
}

export interface Prop {
  requestFn: (arg?: any) => Promise<any>;
  whatYouSent: string;
  routeOnSuccess: string;
  routeOnError: string;
}
